import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { cleanupStaleServiceWorkers } from "@/swCleanup";

// Remove any stale service workers / caches left from older deploys
cleanupStaleServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
